module.exports = __webpack_public_path__ + "static/media/profil.df6b1e40.png";